// Module
var code = "<template>\n    <slot name=\"buttons\"></slot>\n    <div class=\"card-inner\">\n        <slot name=\"containers\"></slot>\n        <div class=\"card-footer\">\n            <slot name=\"footer\"></slot>\n        </div>\n    </div>\n</template>\n";
// Exports
export default code;